import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { Button, Image } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";
import Spinner from "../Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import { PermIdentity } from "@mui/icons-material";
import { fetchPassengerImage } from "../fetchDocs";
import Transactions from "../Corporate/Transactions";
import { Checkbox, Dropdown, Menu, Modal, Space } from "antd";
import jsPDF from "jspdf";
import { handleExportTripDetail } from "../exportTripDetail";
import ReactToPrint from "react-to-print";
// import { jsreport } from "jsreport";
// import jsreport from "jsreport-core";
import jsreport from "jsreport-browser-client-dist";
import Passenger from "../reports/Passenger";
import PassengerTrips, {
  exportExcelPassengerTrips,
} from "../reports/PassengerTrips";
import { DownOutlined } from "@ant-design/icons";

const ViewPassenger = () => {
  const params = useParams();
  const id = params.id;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");

  const [address, setAddress] = useState("");
  const [balance, setBalance] = useState("");
  const [msg, setMsg] = useState("");
  const [passengerImage, setPassengerImage] = useState(null);
  const [rating, setRating] = useState();
  const [miles, setMiles] = useState();
  const [memberScince, setMemberSince] = useState();
  const [documents, setDocuments] = useState();
  const [vehicle, setVehicle] = useState({});
  let [loading, setLoading] = useState(true);
  let [tripsLoading, setTripsLoading] = useState(true);
  const [trips, setTrips] = useState([]);
  const history = useNavigate();

  const initialValues = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    address: "",
    vehicleId: "",
    rating: "",
    miles: "",
    gender: "",
    memberScince: "",
    passengerImage: "",
    documents: "",
    refresh_token: "",
    trips: [],
    creditHistory: [],
    balance: "",
    vehicle: [],
  };

  const getPassenger = async () => {
    try {
      const response = await axios.get("/passenger/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      });

      const passengerData = response.data.passenger;

      setFirstName(passengerData.firstName);
      setLastName(passengerData.lastName);
      setPhoneNumber(passengerData.phoneNumber);
      setGender(passengerData.gender);
      setAddress(passengerData.address);
      setRating(passengerData.rating);
      setMemberSince(passengerData.memberScince);
      setMiles(passengerData.miles);

      // Fetch the image with headers
      if (
        passengerData.passengerImage != null ||
        passengerData.passengerImage != undefined
      ) {
        fetchPassengerImage(passengerData.passengerImage, setPassengerImage);
      } else {
        setPassengerImage(passengerData.passengerImage);
      }

      const respon = await axios.get("/passengerTrips/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      });
      const newData = respon.data.map((res) => {
        return {
          ...res,
          driver: {
            ...res.driver,
            name: res.driver.firstName + " trips" + res.driver.lastName,
          },
        };
      });
      console.log("=======passenger trips====", newData);
      setTrips(newData);
      setTripsLoading(false);

      setLoading(false);
    } catch (err) {
      notifyError();
      setLoading(false);
      setTripsLoading(false);
    }
  };

  // axios
  //   .get("/passenger/" + id)
  //   .then((res) => {
  //     setFirstName(res.data.passenger.firstName);
  //     setLastName(res.data.passenger.lastName);
  //     setPhoneNumber(res.data.passenger.phoneNumber);
  //     setGender(res.data.passenger.gender);
  //     setAddress(res.data.passenger.address);
  //     setRating(res.data.passenger.rating);
  //     // console.log(
  //     //   res.data.passenger.passengerImage.toLowerCase(),
  //     //   "==========passwenger image======",
  //     //   res.data.passenger.passengerImage.toLowerCase() === "null"
  //     // );
  //     setPassengerImage(res.data.passenger.passengerImage);
  //     setMemberSince(res.data.passenger.memberScince);
  //     setLoading(false);
  //   })
  //   .catch((err) => {
  //     notifyError();
  // });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  // const getTrips = async () => {
  //   const response = await axios.get("/passengerTrips/" + id).then(res => {
  //     setTrips(res.data);
  //     console.log("trips" , res.data)
  //     setTripsLoading(false);
  //   })
  //     .catch(err => {
  //       notifyError();
  //     });
  // };

  useEffect(() => {
    //getTrips();
    getPassenger();
  }, []);

  const columns_expo = React.useMemo(
    () => [
      {
        Header: "Date",
        accessor: "createdAt",
      },
      {
        Header: "Driver",
        accessor: "driver.name",
      },
      {
        Header: "From",
        accessor: "pickUpPlace",
      },
      {
        Header: "To",
        accessor: "destinationPlace",
      },

      {
        Header: "Amount Paid",
        accessor: "actualPrice",
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  const reportStyles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100vh",
      marginTop: "50px",
    },
    button: {
      // backgroundColor: "green",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      display: "flex",
      justifyContent: "space-around",
    },
    buttonTwo: {
      border: "none",
      transition: "background-color 0.3s",
      display: "flex",
      justifyContent: "space-around",
      fontSize: "20px",
    },
    contain: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#198754",
      // margin: "10px",
      // padding: "20px 20px",
      // width: "270px",
      fontSize: "22px",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    icon: {
      fontWeight: "bold",
      fontSize: "20px",
      color: "white",
      marginLeft: "7px",
      marginRight: "3px",
    },
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportTripDetail(
      trips,
      columns_expo,
      "passenger",
      "passenger_details.pdf",
      selectedColumns,
      firstName + " " + lastName
    );
  };
  const [report, setReport] = useState(null);

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const printableRef = useRef(null);

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };

  const [formats, setFormats] = useState("PDF");
  const items = [
    {
      label: <p style={reportStyles.buttonTwo}>In EXCEL format</p>,
      key: "EXCEL",
    },
  ];

  const handleDropdownChange = (selectedFormat) => {
    if (selectedFormat === "EXCEL") {
      exportExcelPassengerTrips(firstName + "_" + lastName, trips);
    } else {
      setFormats("PDF");
    }
  };

  return (
    <div className="content-wrappers">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h2
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "22px",
                }}
              >
                Passenger Detail
              </h2>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/passengers">Home</a>
                </li>
                <li className="breadcrumb-item active">Passenger Detail</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            {loading && (
              <div>
                <Spinner />
              </div>
            )}
            {!loading && (
              <div className="col-md-3">
                <div
                  className="card card-primary card-outline"
                  style={{
                    boxShadow: " rgba(0, 0, 0, 0.09) 0px 3px 12px 0px",
                    borderRadius: "10px",
                  }}
                >
                  <div className="card-body box-profile">
                    <div className="text-center">
                      {passengerImage?.toLowerCase() !== null &&
                      passengerImage?.toLowerCase() !== undefined ? (
                        <img
                          className=" img-fluid "
                          src={passengerImage}
                          height="300px"
                          width="300px"
                          alt="passenger picture"
                        />
                      ) : (
                        <PermIdentity
                          style={{ color: "green", fontSize: 350 }}
                        />
                      )}
                      {/* {passengerImage == null &&
                        < AccountBoxIcon style={{ color: "black", fontSize: 300 }} />
                      } */}
                    </div>

                    <h3 className="profile-username text-center">
                      {firstName} {lastName}{" "}
                    </h3>

                    <p className="text-muted text-center">
                      {phoneNumber} / {gender}{" "}
                    </p>
                    <p className="text-muted text-center">
                      Member Scince {memberScince}{" "}
                    </p>

                    <ul className="list-group list-group-unbordered mb-3">
                      {/* <li className="list-group-item">
                    <b>Trips</b> <a className="float-right">{trips.length}</a>
                      </li> */}
                      <li className="list-group-item">
                        <b>Rating</b> <a className="float-right">{rating}</a>
                      </li>
                      <li className="list-group-item">
                        <b>Miles</b> <a className="float-right">{miles}</a>
                      </li>
                      <li className="list-group-item">
                        <b>Trips</b>{" "}
                        <a className="float-right">{trips.length}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {tripsLoading && (
              <div>
                <Spinner />
              </div>
            )}
            {!tripsLoading && (
              <div
                className="col-md-9 card card-primary card-outline"
                ref={printableRef}
                style={{
                  boxShadow: " rgba(0, 0, 0, 0.09) 0px 3px 12px 0px",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
              >
                <div
                  className="card-header"
                  style={
                    {
                      // display: "flex",
                      // justifyContent: "space-between",
                    }
                  }
                >
                  <span
                    className=""
                    style={{
                      fontWeight: "bold",
                      fontSize: "15px",
                    }}
                  >
                    Trips History
                  </span>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginLeft: "auto",
                      gap: "10px",
                    }}
                  >
                    <Button onClick={showModal} className="btn btn-success bt">
                      Export
                    </Button>
                    <div style={reportStyles.contain}>
                      <ReactToPrint
                        trigger={() => (
                          <Button
                            style={reportStyles.button}
                            onClick={handlePrintButtonClick}
                            className="btn btn-success bt p-3"
                          >
                            Print(PDF)
                          </Button>
                        )}
                        content={() => prRef.current}
                      />
                      <Dropdown
                        overlay={
                          <Menu>
                            {items.map((item) => (
                              <Menu.Item
                                key={item.key}
                                onClick={() => handleDropdownChange(item.key)}
                              >
                                {item.label}
                              </Menu.Item>
                            ))}
                          </Menu>
                        }
                        trigger={["click"]}
                      >
                        <a onClick={(e) => e.preventDefault()}>
                          <Space>
                            <DownOutlined style={reportStyles.icon} />
                          </Space>
                        </a>
                      </Dropdown>
                      <div
                        style={{
                          display: isPrintableComponentVisible
                            ? "block"
                            : "none",
                        }}
                      >
                        <PassengerTrips
                          name={firstName + " " + lastName}
                          trips={trips}
                          prRef={prRef}
                        />
                      </div>
                    </div>
                  </div>

                  <Modal
                  style={{marginTop: "60px"}}
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>
                </div>

                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th width="10%">Date</th>
                      <th width="20%">Driver</th>
                      <th width="20%"> From</th>
                      <th width="20%">To</th>
                      <th width="10%">Amount Paid</th>
                      <th width="10%">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trips.map((trip) => {
                      if (
                        trip.createdAt === undefined ||
                        trip.createdAt === null
                      ) {
                        return (
                          <ClipLoader
                            color={"$ffffff"}
                            loading={true}
                            cssOverride={true}
                            size={150}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        );
                      } else {
                        return (
                          <tr>
                            <td>{trip.createdAt.substring(0, 16)}</td>
                            {trip.driver != null && (
                              <td>
                                {trip.driver.firstName +
                                  " " +
                                  trip.driver.lastName}
                              </td>
                            )}

                            <td> {trip.pickUpPlace}</td>
                            <td> {trip.destinationPlace}</td>
                            {trip.status == "Ended" && (
                              <td> {trip.actualPrice}&nbsp;ETB</td>
                            )}
                            {trip.status == "Active" && (
                              <td>
                                {" "}
                                {trip.estimatedPrice}&nbsp;ETB - Estimated{" "}
                              </td>
                            )}
                            {trip.status == "Active" && (
                              <td>
                                <span class="badge bg-warning">Active</span>
                              </td>
                            )}
                            {trip.status == "Ended" && (
                              <td>
                                <span class="badge bg-success">Completed</span>
                              </td>
                            )}
                          </tr>
                        );
                      }
                    })}
                  </tbody>
                </table>

                {/* <table class="table table-bordered">
            <thead>
              <tr>
                <th >Date</th>
                
                <th>Amount</th>
                
              </tr>
            </thead>
            <tbody>
              {creditHistory.map(ch => {
                return (
                  <tr>
                   
                    <td>{ch.amount}</td>
                    <td>{ch.createdAt}</td>
                   
                  </tr>
                );
              })}
            </tbody>
          </table> */}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewPassenger;
